import api from '../../utils/api';

const WA_NUMBER = '918595675155';

function buildWhatsAppUrl(payload) {
  const lines = [
    'Hi BookMyLibrary team, I want to list my institute.',
    '',
    `Director: ${payload.ownerName}`,
    `Phone: +91${payload.phone}`,
    `Email: ${payload.email}`,
    `Institute: ${payload.instituteName}`,
    `City: ${payload.city}`,
    `Primary courses: ${Array.isArray(payload.primaryCourses) ? payload.primaryCourses.join(', ') : payload.primaryCourses}`,
    payload.currentStudents ? `Current students: ${payload.currentStudents}` : null,
    payload.message ? `Notes: ${payload.message}` : null,
  ]
    .filter(Boolean)
    .join('\n');
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(lines)}`;
}

export async function submitInstituteLead(payload) {
  const body = { ...payload, source: 'join-us-as-institute' };
  try {
    const res = await api.post('/marketing/institute-leads', body);
    if (res?.data && res.data.error === false) {
      return { ok: true, data: res.data.data };
    }
    throw new Error('Unexpected response');
  } catch (err) {
    try {
      window.open(buildWhatsAppUrl(payload), '_blank', 'noopener,noreferrer');
    } catch (_) {
      /* ignore popup failures */
    }
    return { ok: false, fallback: 'whatsapp' };
  }
}
